export enum SourceOfPick {
    Upsell = 'Upsell',
    OutrightsGrid = 'OutrightsGrid',
    Other = 'Other',
    BetStationMarquee = 'BetStationMarquee',
    EventDetails = 'EventDetails',
    LineSwitcher = 'LineSwitcher',
    MultiGenerator = 'MultiGenerator',
    WorldCupHub = 'WorldCupHub',
    EmbeddedBetBuilder = 'EmbeddedBetBuilder',
    OverlayBetBuilder = 'OverlayBetBuilder',
    TeamGrouping = 'TeamGrouping',
}

export interface IPickTracking {
    //below was added to support dynamic keys that are added to pick tracking without being defined here, this is a hack, and should never be reused or copied
    [key: string]: number | string | boolean | undefined | { [key: string]: string };
    source: string;
    sourceOfBetSuffix?: string;
    affiliate?: boolean;
    numpadAction?: string | number;
    additional?: { [key: string]: string };
    sourceOfPick?: SourceOfPick;
    betDetails?: string;
    betCalender?: string;
    controllerTabName?: string;
    playerName?: string;
    betType?: string;
    gameDetails?: string;
    moduleType?: string;
    contentPosition?: string;
    variant?: string;
    sheetviewSuffix?: string;
    parentLeagueId?: number;
    betPickType?: string;
    startDate?: string;
    fixtureType?: string;
    pricingState?: string;
    bestOddsGuarantee?: boolean;
    isRaceOff?: boolean;
}
